var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
/* Template for rendering page number in pagination

    page: passed object with options for this page
    isCurrent: if this page is current page
    number: this page number

*/
__p+='\n\n';

  let {
    page
  } = options;

__p+='\n\n\n<span class="page'+
((__t=( page.isCurrent ? ' current': ''))==null?'':__t)+
'" >\n    '+
((__t=( page.isCurrent ? '': '<a data-omtag = "srp:paging:#{page}">'))==null?'':__t)+
''+
((__t=( page.number))==null?'':__t)+
''+
((__t=( page.isCurrent ? '': '</a>'))==null?'':__t)+
'\n</span>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/pagination/page.jst.ejs